import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { Game } from '../../../Core'

import * as indicatorsActions from '../../Indicators/indicators.actions'
import * as mapActions from '../../Map/map.actions'
import * as mapSelectors from '../../Map/map.selectors'

import * as FirebaseActions from '../../../Core/Firebase/firebase.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import UIButton from '../../UI/UIButton'

import * as tutorialSelectors from '../../../Tutorial/tutorial.selectors'

class RankingButton extends React.Component {
  handleBackToBase() {
    const {
      setVisitorMap,
      addScreen,
      setVisitorIndicators,
      attacking,
      toggleAttack,
      setListenerType,
      clearSprites,
      isTutorialMode,
    } = this.props
    !isTutorialMode && attacking ? toggleAttack() : null
    clearSprites()
    setVisitorMap({
      visitorId: null,
      mapId: null,
      buildings: {},
      removedRocks: {},
    })
    setVisitorIndicators(null)
    setListenerType(null)
    addScreen('ranking_screen')
  }

  componentDidMount() {
    const { removePopup } = this.props

    removePopup('tile_popup')
  }

  render() {
    const { addScreen, visitorMap, addHowlSound } = this.props

    return (
      <UIButton
        icon={'icon-satelite'}
        id={'ranking'}
        position={'position--absolute right bottom z-index1'}
        action={() => {
          !visitorMap.mapId ? addScreen('ranking_screen') : this.handleBackToBase()
          addHowlSound('button_click_icon')
        }}
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  setVisitorMap: bindActionCreators(mapActions.setVisitorMap, dispatch),
  setVisitorIndicators: bindActionCreators(indicatorsActions.setVisitorIndicators, dispatch),
  toggleAttack: bindActionCreators(mapActions.toggleAttack, dispatch),
  addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  setListenerType: bindActionCreators(FirebaseActions.setListenerType, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  clearSprites: bindActionCreators(mapActions.clearSprites, dispatch),
})

const mapStateToProps = (state) => ({
  visitorMap: mapSelectors.getVisitorMap(state),
  attacking: mapSelectors.getAttackState(state),
  isTutorialMode: tutorialSelectors.isTutorialMode(state),
})

RankingButton.propTypes = {
  attacking: PropTypes.any,
  setVisitorMap: PropTypes.func,
  setListenerType: PropTypes.func,
  clearSprites: PropTypes.func,
  toggleAttack: PropTypes.func,
  removePopup: PropTypes.func,
  setVisitorIndicators: PropTypes.func,
  addScreen: PropTypes.func,
  visitorMap: PropTypes.object,
  addHowlSound: PropTypes.func,
  isTutorialMode: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(RankingButton)
